import { useState, useCallback } from 'react';
import { WHATSAPP_ENABLED } from '../featureFlags';

const useWhatsAppLink = () => {
    const [isLinkingWhatsApp, setIsLinkingWhatsApp] = useState(false);

    const linkWhatsApp = useCallback(async (phoneNumber, conversationId) => {
        if (!WHATSAPP_ENABLED || !phoneNumber.trim() || !conversationId) return;
        setIsLinkingWhatsApp(true);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch('/api/whatsapp/link', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
                },
                body: JSON.stringify({ conversationId, phoneNumber }),
            });

            console.log('[useWhatsAppLink] 🚀 ', JSON.stringify({ phoneNumber, conversationId }, null, 2));

            if (res.ok) {
                await fetch('/api/whatsapp/start', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ phoneNumber }),
                });
            }
        } catch (err) {
            console.error('Failed to link WhatsApp hook  :', err.message);
        } finally {
            setIsLinkingWhatsApp(false);
        }
    }, []);

    return { linkWhatsApp, isLinkingWhatsApp };
};

export default useWhatsAppLink;
